import React from 'react';
import PropTypes from 'prop-types';

import RadioButtonGroup from '../../../RadioButtonGroup';

import {
  StyledQuestionBlock,
  StyledQuestionLabel,
} from './styles';

const QuestionBlock = ({
  label,
  options,
  selectedOption,
  onOptionChange,
  disabled,
}) => (
  <StyledQuestionBlock>
    <StyledQuestionLabel>{label}</StyledQuestionLabel>
    <RadioButtonGroup
      options={options}
      selectedOption={selectedOption}
      onOptionChange={onOptionChange}
      disabled={disabled}
    />
  </StyledQuestionBlock>
);

QuestionBlock.propTypes = {
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  selectedOption: PropTypes.string.isRequired,
  onOptionChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

QuestionBlock.defaultProps = {
  disabled: false,
};

export default QuestionBlock;
